import React, { Component } from 'react';

import { Link } from 'react-router-dom';
class BookingPayment extends Component {

  render() {
    return (
      <div className="container mt-2">
        <form>
          <div className="row">          
              <div className="col-md-6">
                <div className="card">
                <h5 class="card-header text-left">Payment Information</h5>
                  <div className="card-body">
                    <input className="form-control mb-1" type="text" placeholder="Card Number" />
                    <input className="form-control mt-1 mb-1" type="text" placeholder="Exp Date MM/YY" />
                    <input className="form-control mt-1 mb-1" type="text" placeholder="Security Code" />
                    
                    <input className="form-control mt-3" type="text" placeholder="Name" />

                    <h6 class="card-title text-left mt-4">Billing Address</h6>

                    <input className="form-control mt-1 mb-1" type="text" placeholder="Street" />
                    <input className="form-control mt-1 mb-1" type="text" placeholder="City" />
                    <input className="form-control mt-1 mb-1" type="text" placeholder="State" />
                    <input className="form-control mt-1 mb-1" type="text" placeholder="Postal Code" />
                  </div>

                  <div class="card-footer text-muted text-left" style={{ fontSize: 'small'}}>
                    Your card will not be charged until your booking request is accepted.
                  </div>
                </div>

                <Link className="btn btn-primary pull-right mt-3" to="/booking/protection">Request Booking</Link>
              </div>

              <div className="col-md-6">   
                <div className="card">
                  <div className="card-body">
                    <h6 class="card-title text-left">Room to Roam in Santa Barbara</h6>
                    <p class="card-text text-left">Santa Barbara, CA</p>

                    <div className="form-row">
                      <div className="col-md-4">
                        <input className="form-control mb-1" type="text" placeholder="Arrive" />
                      </div>

                      <div className="col-md-4">
                        <input className="form-control mb-1" type="text" placeholder="Depart" />
                      </div>

                      <div className="col-md-4">
                        <input className="form-control mb-1" type="text" placeholder="Nights" />
                      </div>
                    </div>
                  </div>

                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <span className="pull-left">
                        $240 x 4 nights
                      </span>

                      <span className="pull-right">
                        $960.00
                      </span>
                    </li>
                    <li className="list-group-item">
                      <span className="pull-left">
                        Cleaning Fee
                      </span>

                      <span className="pull-right">
                        $55.00
                      </span>
                    </li>
                    <li className="list-group-item">
                      <span className="pull-left">
                        Service Fee
                      </span>

                      <span className="pull-right">
                        $106.00
                      </span>
                    </li>
                    <li className="list-group-item">
                      <span className="pull-left" style={{ fontWeight: 'bold'}}>
                        Total
                      </span>

                      <span className="pull-left" style={{ fontWeight: 'bold'}}>
                        $1,121.00
                      </span>
                    </li>

                    <li className="list-group-item">
                      <span className="pull-left">
                        Refundable Deposit
                      </span>

                      <span className="pull-right">
                        $500.00
                      </span>
                    </li>

                    <li className="list-group-item">
                      <span className="pull-left">
                        Total + Deposit
                      </span>

                      <span className="pull-right">
                        $1,621.00
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
          </div>
        </form>
      </div>
    );
  }
}

export default BookingPayment;


